import React from 'react';
import { Container } from 'react-bootstrap';
import './sorumlulukReddi.css';

const SorumlulukReddi = () => {
  return (
    <Container className="sorumluluk-reddi-container py-5">
      <h1 className="page-title mb-4">Sorumluluk Reddi</h1>
      
      <div className="content">
        <p>
          1-Kurum, site kullanıcılarına sunduğu bilgilerin doğru olması için her türlü gayreti göstermekle beraber yanlış veya eksik bilgiden sorumlu değildir. 
          Kurum, sitede yer alan bilgilerin tam ve doğru olduğunu veya sayfaya kesintisiz giriş sağlanacağını garanti etmemektedir. 
          İşbu sitede yer alan beyanlar hukuken taahhüt niteliğinde sayılmamaktadır ve bağlayıcı değildir. 
          Kurum bu bilgilerle üçüncü şahısların haklarının ihlal edilmemesi, belirli bir amaç için uygunluk ve/veya bilgisayar virüsü bulunmamasına ilişkin garantiler dâhil yasal olarak hiçbir garanti vermemektedir.
        </p>

        <p>
          2-Kurum, sitenin kullanılması, kullanılamaması ile bünyesinde sunulan bilgiler veya siteye bağlı olarak yapılan eylemler ve alınan kararlar nedeniyle 
          kullanımında meydana gelen aksaklıktan, sitenin içerdiği materyalden, sitenin kullanımından sonra alınan bir karar veya yapılan bir eylemden doğan, 
          kontrat, haksız fiil veya başka türlü (sınırlama olmadan, iş kaybından doğan zararlar veya kâr kaybı dâhil) zararlardan sorumlu değildir.
        </p>

        <p>
          3-Bu sitede yer alan bilgiler ve her türlü elektronik doküman Kurum tarafından herhangi bir maddi menfaat temin edilmeksizin genel anlamda kamuoyunu bilgilendirmek amacıyla hazırlanmıştır. 
          Sitede yer alan bu elektronik dokümanların doğruluğu; yazım hatası, yazılım hatası, aktarım hatası, sistemlerin bozulması veya saldırıya uğraması gibi nedenlerden kaynaklanan hatalara karşı garanti edilmemekte olup 
          bu bilgiler belli bir getirinin sağlanmasına yönelik olarak verilmemektedir. Bu nedenle bu sitede yer alan elektronik dokümanlardaki hatalardan, eksikliklerden ya da bu dokümanlara dayanılarak yapılan işlemlerden doğacak, 
          doğrudan veya dolaylı, her türlü maddi/manevi zararlardan Kurum sorumlu tutulamaz.
        </p>

        <p>
          4-Bu sitenin kullanımı sırasında herhangi bir arıza, hata, eksiklik, kesinti, kusur veya nakilde gecikme, bilgisayar virüsü ya da hat veya sistem arızası sonucu doğrudan ya da dolaylı ortaya çıkan 
          hiçbir zarardan Kurum ve/veya çalışanı, bu tür bir zarar olasılığından haberdar edilmiş olsalar dahi, sorumlu olmazlar.
        </p>

        <p>
          5-Kurum sitenin virüs önlemlerini almış olmakla birlikte, bu konuda bir garanti vermemektedir. Herhangi bir bilgi, belge, uygulama vb. indirmeden önce virüslerden korunma konusunda gerekli önlemlerin alınması tavsiye edilir.
        </p>

        <p>
          6-Kullanım şartlarıyla ilgili ortaya çıkabilecek ihtilaflarda bu metin yasal dayanak kabul edilmek suretiyle Ankara Mahkemeleri ve İcra Daireleri yetkilidir.
        </p>

        <p className="note">
          (Kurum bu yasal uyarıda yer alan tüm koşulları ve hükümleri önceden bir ihbara gerek kalmaksızın değiştirme ve güncelleme hakkını haizdir. 
          "Gizlilik politikası ve Sorumluluk reddi"ni düzenli olarak takip etmek, site kullanıcısının sorumluluğundadır. 
          Yapılan değişikliklerden sonra siteyi kullanmaya devam eden kişi, "Gizlilik politikası ve Sorumluluk reddi"ndeki değişiklikleri kabul etmiş sayılır.)
        </p>
      </div>
    </Container>
  );
};

export default SorumlulukReddi;

